/** @format */

if ((typeof window.Shopify) == 'undefined') {

	window.Shopify = {};

  }

  

  Shopify.imgSizesUrl = function (src, size) {

	  return src

		  .replace(

			  /_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g,

			  "."

		  )

		  .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {

			  return "_" + size + match;

		  });

  }; 

  

class ProductGridSwatch extends HTMLElement {

	constructor() {

		super();

		this.el = this;

		 console.log(this.el);

		this.selectors = {

			swatchElement: "[data-swatch-element]",

			productfeaturedImage: ".product_tile_featured_image",

			productSecondaryImage: ".product_tile_secondary_image",

			activeSwatch: ".active[data-swatch-element]",

			productUrl: "[data-product-item-url]",

		};

		this.container = this.el.parentNode.parentNode.parentNode;

		console.log('Feature Image', this.selectors.productfeaturedImage);
		console.log('Secondry Image', this.selectors.productSecondaryImage);
		console.log('Product URL', this.selectors.productUrl);

		this.featuredImage = this.container.querySelector(

			this.selectors.productfeaturedImage

		);

		this.secondaryImage = this.container.querySelector(

			this.selectors.productSecondaryImage

		);

		this.productUrls = this.container.querySelectorAll(

			this.selectors.productUrl

		);

		this._init();

	}

	_init() {

		this.data = this._loadData(this.el);

		// console.log(this.data);

		this._bindEvents();

	}

	_loadData(el) {

		const dataEl = el.parentNode.querySelector("[data-swatch-data]");

		if (!dataEl) return {};

		const data = dataEl.innerHTML;

		try {

			return JSON.parse(data);

		} catch (error) {

			console.warn(`No data found ${error.message}`);

			return {};

		}

	}

	_bindEvents() {

		this.swatches = this.el.querySelectorAll(this.selectors.swatchElement);

		var element = this.el;

		var activeSelector = this.selectors.activeSwatch;

		this.swatches.forEach((ele) => {

			ele.addEventListener("mouseenter", (e) => {

				// console.log(e);

				element.querySelector(activeSelector).classList.remove("active");

				e.target.classList.add("active");

				var index = e.target.dataset.swatchIndex;

				// this.featuredImage.parentNode.classList.add("loading");

				this.updateCollectionTile(index);

			});

		});

	}

	updateCollectionTile(index) {
		let secondary_image = "";

		for (let i = 0; i < this.data.images.length; i++) {

			if (this.data.images[i] == this.data.variant[index].featured_image) {

				secondary_image = this.data.images[i + 1];

			}

		}

		this.updateImage(

			this.data.variant[index].featured_image,

			secondary_image

		);

		this.updateLink(this.data.variant[index].url);

		// this.updateSale(this.data.variant[index].onsale);

	}

	updateSale(onsale) {

		if (onsale) {

			this.container.classList.add("sale");

		} else {

			this.container.classList.remove("sale");

		}

	}

	updateImage(image1, image2) {

		let featured_image = this.featuredImage,

			secondary_image = this.secondaryImage;

		// console.log(secondary_image);

		if (image1) {

			featured_image.src = Shopify.imgSizesUrl(image1, "533x");

		}

		if (image2) {

			secondary_image.src = Shopify.imgSizesUrl(image2, "533x");

		}

	}

	updateLink(url) {

		// console.log(url);

		this.productUrls.forEach((ele) => {

			ele.href = url;

		});

	}

}

customElements.define("product-grid-swatch", ProductGridSwatch);

